module.exports = __webpack_public_path__ + "img/14.4ef93086.png";